<template>
  <section id="login-page" class="section login">
    <div class="login__logo-container">
      <img src="../../assets/logo-extended.png" />
    </div>
    <form class="box login__form" @submit.prevent="doLoginHandler">
      <b-field>
        <b-input
          v-model="email"
          icon="at"
          placeholder="Email"
          required
          type="email"
        />
      </b-field>
      <b-field>
        <b-input
          v-model="password"
          icon="onepassword"
          password-reveal
          placeholder="Password"
          required
          type="password"
        />
      </b-field>
      <b-button
        class="is-fullwidth"
        :loading="auth.loading"
        native-type="submit"
        type="is-primary"
      >
        LOGIN
      </b-button>
    </form>
    <div class="content has-text-light is-small">
      © Copyright 2018-19 HumbleSchool Pvt Ltd.
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  data() {
    return {
      email: '',
      password: ''
    };
  },
  computed: {
    ...mapGetters('auth', ['parsedError']),
    ...mapState(['auth'])
  },
  methods: {
    ...mapActions(['doLogin']),
    async doLoginHandler() {
      try {
        await this.doLogin({
          email: this.email,
          password: this.password
        });
        this.$router.push('/');
      } catch (error) {
        this.$buefy.toast.open({
          message: this.parsedError,
          type: 'is-danger'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#login-page {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  background-image: $app-gradient;
}

.login {
  &__logo-container {
    margin-top: 4rem;
    width: 100%;
    padding: 0.5rem;
    max-width: 14rem;
  }

  &__form {
    width: 100%;
    max-width: 22rem;
  }
}
</style>
